export default __webpack_public_path__ + "static/media/spain-small.8ca2e999.png";